export default {
  listHeaders() {
    return [
      { text: 'Personel Bilgileri', value: 'adSoyad' },
      { text: 'Santiye', value: 'santiye' },
      { text: 'Pozisyon', value: 'pozisyon' },
      { text: 'Sevk Tarihi', value: 'sevkTarihi' },
      { text: 'Reddet', value: 'Buttons' },
      { text: 'Onayla', value: 'Buttons' },
    ];
  },
};
